Get candidate profile summaries by email addresses.

This returns summary profile information including email, identity verification status, and profile existence.

This query accepts browser tokens that include the `query:seek-candidate-profiles` scope.
